export default "__VITE_ASSET__uGtZZ7LX__"